import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useCallback } from 'react';
import RECAPTCHA_CONFIG from '../config/recaptcha';

export const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const executeRecaptchaAction = useCallback(async (action) => {
    // Skip reCAPTCHA in development
    if (RECAPTCHA_CONFIG.DISABLED) {
      console.log('reCAPTCHA disabled in development');
      return 'development-token';
    }

    if (!executeRecaptcha) {
      console.log('reCAPTCHA not available');
      return null;
    }

    try {
      const token = await executeRecaptcha(action);
      return token;
    } catch (error) {
      console.error('reCAPTCHA execution failed:', error);
      return null;
    }
  }, [executeRecaptcha]);

  const verifyRecaptcha = useCallback(async (action) => {
    // Skip reCAPTCHA verification in development
    if (RECAPTCHA_CONFIG.DISABLED) {
      console.log('reCAPTCHA verification skipped in development');
      return true;
    }

    const token = await executeRecaptchaAction(action);
    
    if (!token) {
      throw new Error('reCAPTCHA verification failed');
    }

    // Send token to backend for verification
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/verify-recaptcha`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
          action
        }),
      });

      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.error || 'reCAPTCHA verification failed');
      }

      return result.success;
    } catch (error) {
      console.error('reCAPTCHA backend verification failed:', error);
      throw error;
    }
  }, [executeRecaptchaAction]);

  return {
    executeRecaptchaAction,
    verifyRecaptcha
  };
};

export default useRecaptcha;
